import type { LeadStatus } from "@crewfsm/contracts";

export const PIPELINE_STATUSES = [
  "NEW",
  "OPEN",
  "CONTACTED",
  "QUALIFIED",
  "LOST",
] as const satisfies readonly LeadStatus[];

export type PipelineStatus = (typeof PIPELINE_STATUSES)[number];

export const PIPELINE_STATUS_LABELS: Record<PipelineStatus, string> = {
  NEW: "New",
  OPEN: "Open",
  CONTACTED: "Contacted",
  QUALIFIED: "Qualified",
  LOST: "Lost",
};

const TRANSITIONS: Record<PipelineStatus, readonly PipelineStatus[]> = {
  NEW: ["OPEN", "CONTACTED", "QUALIFIED", "LOST"],
  OPEN: ["CONTACTED", "QUALIFIED", "LOST"],
  CONTACTED: ["OPEN", "QUALIFIED", "LOST"],
  QUALIFIED: ["CONTACTED", "LOST"],
  LOST: ["OPEN", "CONTACTED", "QUALIFIED"],
};

export function allowedPipelineTransitions(
  status: LeadStatus,
): readonly PipelineStatus[] {
  return isPipelineStatus(status) ? TRANSITIONS[status] : [];
}

export function canMoveLead(
  current: LeadStatus,
  target: PipelineStatus,
): boolean {
  return allowedPipelineTransitions(current).includes(target);
}

export function isPipelineStatus(status: LeadStatus): status is PipelineStatus {
  return (PIPELINE_STATUSES as readonly LeadStatus[]).includes(status);
}
